<template>
  <div>
    <div class="container-page-header">
      <van-tabs v-model:active="menu" @click-tab="onMenuTab" class="top-tabs" title-active-color="#4275FD">
        <van-tab title="我的申请" name="/repair/report/apply"></van-tab>
        <van-tab title="我的审批" name="/repair/report/audit"></van-tab>
        <van-tab title="报修记录" name="/repair/report/record"></van-tab>
      </van-tabs>
      <div class="page-top-line"></div>

      <van-tabbar v-model="active">
        <van-tabbar-item @click="goToApply">
          <span>我的报修</span>
          <template #icon="props">
            <img src="../../../assets/image/repair/repair/repair-one-active.png" :class="props.active"/>
          </template>
        </van-tabbar-item>
        <van-tabbar-item @click="goToRepair" v-show="isShowRepair">
          <span>我的维修</span>
          <template #icon="props">
            <img src="../../../assets/image/repair/repair/repair-two.png" :class="props.active"/>
          </template>
        </van-tabbar-item>
      </van-tabbar>
    </div>
    <div class="container-page-body">
      <div class="pages-search">
        <img class="search-img" src="../../../assets/image/repair/icon_nav_saoyisao@2x.png"
             @click="alertSearchMenu">
        <van-popup
            :close-on-click-overlay="false"
            v-model:show="show"
            round
            position="bottom"
            :style="{ height: '50%' }"
            class="popup-search">
          <div class="popup-search-header">
            <div class="popup-search-header__empty"></div>
            <div class="popup-search-header__title">筛选</div>
            <div class="popup-search-header__cancel" @click="toCancel">取消</div>
          </div>
          <div class="popup-search-body">
            <div class="popup-search-body__status">
              <div class="popup-search-body__status-info">审批状态</div>
              <div class="popup-search-body__status-select">
                <div
                    :class="['popup-search-body__status-option', {'option-active':item.key===tmpParams.operateType}]"
                    v-for="(item, index) in searchForm.operateTypeList"
                    :key="index"
                    @click="operateType(item)">{{ item.title }}
                </div>
              </div>
            </div>
<!--            <div class="popup-search-body__status">
              <div class="popup-search-body__status-info">状态</div>
              <div class="popup-search-body__status-select">
                <div
                    :class="['popup-search-body__status-option', {'option-active':item.key===tmpParams.repairStatus}]"
                    v-for="(item, index) in searchForm.statusList"
                    :key="index"
                    @click="operateStatus(item)">{{ item.title }}
                </div>
              </div>
            </div>-->
          </div>
          <div class="popup-search-footer">
            <div class="popup-search-footer__button button-reset" @click="buttonReset">重置</div>
            <div class="popup-search-footer__button button-confirm" @click="buttonConfirm">确定</div>
          </div>
        </van-popup>
      </div>
      <div class="pages-list">
        <van-list
            v-model:loading="loading"
            :finished="finished"
            finished-text="没有更多了"
            offset="0"
            @load="getList"
        >
          <div class="pages-item"
               v-for="(item, index) in tableData.list"
               :key="index"
               @click="getDetail(item)">
            <div class="pages-item-title">
              <!--<div class="pages-item-title-img" v-show="item.applyHeadUrl !== ''">
                <img :src="item.applyHeadUrl">
              </div>-->
              <div class="pages-item-title-content">{{ item.title || '暂无标题' }}</div>
              <div class="pages-item-title-date">
                {{ item.applyTime }}
              </div>
            </div>
            <div class="pages-item-body">
              <div class="pages-item-body-info">
                <div class="info-desc">{{ item.approveMsg.title || '暂无标题' }}</div>
                <div class="info-icon-label"
                     :style="'background-color: '+
                     (dictInfo.statusList[item.status] ?
                     dictInfo.statusList[item.status].backgroundColor:'#ebebeb')+';color:'+
                     (dictInfo.statusList[item.status] ?
                     dictInfo.statusList[item.status].color:'#999999')+';'">
                  <span class="info-icon-label-right">
                  {{ item.statusName }}
                  </span>
                </div>
              </div>
              <div class="pages-item-body-content">
                {{ item.approveMsg.content || '' }}
                <!--              <div class="info-field">报修地址：</div>-->
                <!--              <div class="info-value">{{ item.repairAddress }}</div>-->
              </div>
              <!--            <div class="pages-item-body-content">-->
              <!--              <div class="info-field">报修内容：</div>-->
              <!--              <div class="info-value">{{ item.msg }}</div>-->
              <!--            </div>-->
            </div>
            <div class="pages-item-footer">
              <div class="pages-item-body-approval" v-show="item.approvalDescription!==''">
                <div class="button-approval">{{ item.approvalDescription }}</div>
              </div>
            </div>
          </div>
        </van-list>
      </div>
    </div>
  </div>

</template>
<script>
import {computed, onMounted, ref} from "vue";
import {useRouter} from "vue-router";
import {Toast, Tab, Tabs, Tabbar, TabbarItem} from "vant";
import {useStore} from "vuex";

export default {
  components: {
    [Tabs.name]: Tabs,
    [Tab.name]: Tab,
    [Tabbar.name]: Tabbar,
    [TabbarItem.name]: TabbarItem,
  },
  setup() {
    const store = useStore();
    const router = useRouter();
    let menu = ref('');
    let active = ref(0);
    let activeName = ref('');
    let loading = ref(false);
    let finished = ref(false);
    let refreshing = ref(false);
    let show = ref(false);
    let isShowRepair = ref(computed(() => store.state.repair.backupMenuPermission));
    let dictInfo = ref({
      statusList: {
        underway: {backgroundColor: '#ffe7d5', color: '#FF8948', name: '审批中'},
        refuse: {backgroundColor: '#ffdde0', color: '#FE4F54', name: '已拒绝'},
        agree: {backgroundColor: '#d9e4ff', color: '#4174FD', name: '已同意'},
        revoke: {backgroundColor: '#ebebeb', color: '#999999', name: '已撤消'},
        0: {backgroundColor: '#ffe7d5', color: '#FF8948', name: '待分配'},
        1: {backgroundColor: '#d9e4ff', color: '#4174FD', name: '维修中'},
        2: {backgroundColor: '#cdead6', color: '#00C73D', name: '维修完成'},
      },
    });
    let searchForm = ref({
      typeList: [],
      operateTypeList: [
        {
          key: 'pending',
          title: '审批中',
        },
        {
          key: 'processed',
          title: '已审批',
        },
        {
          key: 'cc',
          title: '抄送我',
        },
      ],
      statusList: [
        {
          key: 'underway',
          title: '审批中',
        },
        {
          key: 'refuse',
          title: '已拒绝',
        },
        {
          key: 'agree',
          title: '已同意',
        },
        {
          key: 'revoke',
          title: '已撤消',
        },
        {
          key: '0',
          title: '待分配',
        },
        // {
        //   key: '1',
        //   title: '维修中',
        // },
        // {
        //   key: '2',
        //   title: '维修完成',
        // },
      ],
    });
    let tableData = ref({
      list: [],
      total: 0,
    });
    let tmpParams = ref({
      operateType: 'pending',
      repairStatus: '',
    })
    let queryParams = ref({
      searchStatusList: [],
      operateType: 'pending',
      bizTypeList: ['repair'],
      pageNo: 1,
      pageSize: 10,
    });

    const filterObj = (obj) => {
      for (const i in obj) {
        if (obj[i] === '' || obj[i] === null || obj[i] === 'null') {
          delete obj[i]
        }
      }
      return obj;
    };

    const getListApi = (params) =>
        store.dispatch("repair/getAuditList", params);

    const getList = async () => {
      loading.value = true;
      if (refreshing.value) {
        queryParams.value.pageNo = 1;
        tableData.value.list = [];
        refreshing.value = false;
      }

      let r = await getListApi({
        ...filterObj(queryParams.value)
      });

      if (r.message == "success") {
        tableData.value.total = r.data.total;
        tableData.value.list = tableData.value.list.concat(r.data.list);
        queryParams.value.pageNo ++;
      } else {
        Toast.fail(r.message);
      }

      loading.value = false;
      if (!r.data || r.data.list.length < queryParams.value.pageSize) {
        finished.value = true;
      }
    };

    const getDetail = (item) => {
      router.push(`/repair/report/auditDetail?id=` + item.detailId)
    };

    const toCancel = () => {
      show.value = false;
      tmpParams.value.operateType = queryParams.value.operateType;
      tmpParams.value.repairStatus = queryParams.value.searchStatusList[0] || '';
    };

    const alertSearchMenu = () => {
      show.value = true;
    };

    const operateType = (item) => {
      console.log('选择状态类型')
      tmpParams.value.operateType = item.key;
    };

    const operateStatus = (item) => {
      console.log('选择状态')
      tmpParams.value.repairStatus = item.key;
    };

    const buttonReset = () => {
      if (loading.value) {
        Toast.fail("页面加载中...")
        return;
      }
      // 清理查询数据
      queryParams.value.operateType = 'pending';
      tmpParams.value.operateType = 'pending';
      queryParams.value.searchStatusList = [];
      tmpParams.value.repairStatus = '';
      console.log('buttonReset请求接口', queryParams.value.searchStatusList, queryParams.value.operateType)
      refreshing.value = true;
      getList();
      show.value = false;
    };

    const buttonConfirm = () => {
      if (loading.value) {
        Toast.fail("页面加载中...");
        return;
      }
      if (tmpParams.value.operateType === '') {
        Toast.fail("筛选条件不能为空");
      } else {
        queryParams.value.operateType = tmpParams.value.operateType;
        if(tmpParams.value.repairStatus !== ''){
          queryParams.value.searchStatusList = [tmpParams.value.repairStatus];
        }
        console.log('buttonConfirm请求接口', queryParams.value.searchStatusList)
        refreshing.value = true;
        getList();
        show.value = false;
      }
    };

    const onClickTab = (title) => {
      activeName.value = router.currentRoute.value.path;
      if (title.name !== router.currentRoute.value.path) {
        router.replace(title.name)
      }
    };
    const onMenuTab = (title) => {
      menu.value = router.currentRoute.value.path;
      if (title.name !== router.currentRoute.value.path) {
        router.replace(title.name)
      }
    };
    const goToApply = () => {
      if (router.currentRoute.value.path !== '/repair/report/apply' &&
          router.currentRoute.value.path !== '/repair/report/audit' &&
          router.currentRoute.value.path !== '/repair/report/record') {
        console.log(router.currentRoute.value.path);
        router.push('/repair/report/apply').catch(err => {
          console.log('跳转异常：', err)
        });
      }
    };
    const goToRepair = () => {
      if (router.currentRoute.value.path !== '/repair/report/service') {
        console.log(router.currentRoute.value.path);
        router.push(`/repair/report/service`).catch(err => {
          console.log('跳转异常：', err)
        });
      }
    };

    const getRepairPermissionApi = (params) => store.dispatch("repair/getRepairPermission", params);
    const getRepairPermission = async () => {
      let r = await getRepairPermissionApi({});

      if (r.message == "success") {
        isShowRepair.value = r.data;
        store.commit('repair/setMenuPermission', r.data)
      }
    };

    onMounted(() => {
      onClickTab({name:router.currentRoute.value.path})
      onMenuTab({name:router.currentRoute.value.path})
      getRepairPermission();
    })

    return {
      activeName,
      onClickTab,

      loading,
      finished,
      refreshing,
      show,
      dictInfo,
      searchForm,
      tableData,
      tmpParams,
      queryParams,
      menu,
      active,
      isShowRepair,

      filterObj,
      getList,
      getDetail,
      toCancel,
      alertSearchMenu,
      operateType,
      operateStatus,
      buttonReset,
      buttonConfirm,
      onMenuTab,
      goToApply,
      goToRepair,
    };
  },
};
</script>
<style lang="less" scoped>
:deep(.van-tabs__line) {
  background-color: #4275FD;
  width: 20px;
}

.container-page-header {
  margin-bottom: 48px;

  .top-tabs {
    position: fixed;
    top: 0px;
    left: 0;
    right: 0;
    z-index: 900;
  }

  .page-top-line {
    position: fixed;
    top: 44px;
    left: 0;
    right: 0;
    z-index: 901;
    height: 3px;
    background-color: #ffffff;
    border-bottom: 1px solid #F2F4FA;
  }
}

.container-page-body {
  background-color: #F2F4FA;

  .pages-search {
    height: 24px;
    padding: 10px;
    position: relative;

    .search-img {
      position: absolute;
      right: 10px;
      width: 24px;
    }
  }

  .pages-list {
    padding: 0px 10px 50px 10px;
    min-height: 540px;

    .pages-item {
      background-color: #FFFFFF;
      margin-bottom: 8px;
      border-radius: 10px;

      .pages-item-title {
        color: #999999;
        font-size: 13px;
        padding: 0 12px;
        height: 44px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        border-bottom: 1px solid #E5E5E5;

        .pages-item-title-img img {
          width: 20px;
          height: 20px;
          border-radius: 50%;
        }

        .pages-item-title-content {
          width: 188px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }

      .pages-item-body {
        padding: 12px;

        .pages-item-body-info {
          font-weight: bold;
          display: flex;
          align-items: center;
          justify-content: flex-start;
          margin-bottom: 12px;

          .info-icon {
            display: inline-block;
            width: 74px;
            height: 24px;
            line-height: 24px;
            background-color: #FF8948;
            font-size: 13px;
            text-align: center;
            transform: skewX(-15deg);
            border-radius: 2px;
            color: #FFFFFF;

            .info-icon-right {
              display: inline-block;
              transform: skewX(15deg);
            }
          }

          .info-icon-label {
            font-weight: normal;
            position: absolute;
            right: 10px;
            display: inline-block;
            width: 74px;
            height: 24px;
            line-height: 24px;
            background-color: #FF8948;
            font-size: 13px;
            text-align: center;
            border-top-left-radius: 24px;
            border-bottom-left-radius: 24px;
            color: #FFFFFF;
          }

          .info-desc {
            font-size: 17px;
            color: #333333;
          }

        }

        .pages-item-body-content {
          color: #666666;
          font-size: 15px;
          margin-top: 0px;
          white-space: pre-line;

          .info-field {
            width: 76px;
            height: 20px;
            float: left;
          }

          .info-value {
            display: table;
          }
        }
      }

      .pages-item-footer {
        padding: 0 12px;

        .pages-item-body-allocate {
          border-top: 1px solid #E5E5E5;
          text-align: center;

          .button-allocate {
            width: 100%;
            height: 40px;
            line-height: 40px;
            text-align: center;
            color: #4174FD;
            font-size: 15px;
          }
        }

        .pages-item-body-approval {
          //border-top: 1px solid #E5E5E5;
          text-align: center;

          .button-approval {
            width: 100%;
            height: 30px;
            //line-height: 20px;
            text-align: left;
            color: #FF8948;
            font-size: 15px;
          }
        }
      }
    }
  }

  .popup-search {

    .popup-search-header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 54px;
      margin-bottom: 25px;

      .popup-search-header__empty {
        width: 40px;
        height: 54px;
        line-height: 54px;
      }

      .popup-search-header__title {
        height: 54px;
        line-height: 54px;
        font-weight: 500;
        text-align: center;
        font-size: 17px;
        color: #333333;
      }

      .popup-search-header__cancel {
        height: 54px;
        line-height: 54px;
        width: 40px;
        padding: 0 10px;
        font-size: 15px;
        color: #333333;
      }
    }

    .popup-search-body {
      width: 100%;
      min-height: 180px;
      border-bottom: 1px solid #E5E5E5;
      margin-bottom: 12px;
      overflow: hidden;

      .popup-search-body__status {
        position: relative;
        margin-bottom: 15px;

        .popup-search-body__status-info {
          padding: 0 12px;
          color: #999999;
          font-size: 15px;
          margin-bottom: 10px;
        }

        .popup-search-body__status-select {
          width: 100%;
          padding: 0 8px;
          position: relative;
          overflow: hidden;

          .popup-search-body__status-option {
            float: left;
            border: 1px solid #f3f4fb;
            background-color: #f3f4fb;
            color: #333333;
            width: 110px;
            height: 36px;
            line-height: 36px;
            text-align: center;
            border-radius: 36px;
            margin: 5px 4px;
            font-size: 13px;
          }

          .option-active {
            border: 1px solid #4275FD;
            background-color: #dae4fe;
            color: #4275FD;
          }

        }

      }
    }

    .popup-search-footer {
      clear: both;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 12px;

      .popup-search-footer__button {
        padding: 10px 70px;
        border: 1px solid #4174FD;
        border-radius: 20px;
        font-size: 15px;
      }

      .button-reset {
        color: #4275FD;
        background-color: #ffffff;
      }

      .button-confirm {
        color: #ffffff;
        background-color: #4174FD;
      }

    }
  }

  .pages-fix-apply {
    position: fixed;
    bottom: 60px;
    right: 6px;

    .fix-img {
      img {
        width: 109px;
        height: 46px;
      }
    }
  }
}
</style>
